import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, AlertService, JhiLanguageService } from 'ng-jhipster';

import { Marketplace } from './marketplace.model';
import { MarketplacePopupService } from './marketplace-popup.service';
import { MarketplaceService } from './marketplace.service';
import { Branch, BranchService } from '../branch';

@Component({
    selector: 'jhi-marketplace-dialog',
    templateUrl: './marketplace-dialog.component.html'
})
export class MarketplaceDialogComponent implements OnInit {

    marketplace: Marketplace;
    authorities: any[];
    isSaving: boolean;

    branches: Branch[];
    constructor(
        public activeModal: NgbActiveModal,
        private jhiLanguageService: JhiLanguageService,
        private alertService: AlertService,
        private marketplaceService: MarketplaceService,
        private branchService: BranchService,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['marketplace']);
    }

    ngOnInit() {
        this.isSaving = false;
        this.authorities = ['ROLE_USER', 'ROLE_ADMIN'];
        this.branchService.query().subscribe(
            (res: Response) => { this.branches = res.json(); }, (res: Response) => this.onError(res.json()));
    }
    clear() {
        this.activeModal.dismiss('cancel');
    }

    save() {
        this.isSaving = true;
        if (this.marketplace.id !== undefined) {
            this.marketplaceService.update(this.marketplace)
                .subscribe((res: Marketplace) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        } else {
            this.marketplaceService.create(this.marketplace)
                .subscribe((res: Marketplace) =>
                    this.onSaveSuccess(res), (res: Response) => this.onSaveError(res));
        }
    }

    private onSaveSuccess(result: Marketplace) {
        this.eventManager.broadcast({ name: 'marketplaceListModification', content: 'OK'});
        this.isSaving = false;
        this.activeModal.dismiss(result);
    }

    private onSaveError(error) {
        try {
            error.json();
        } catch (exception) {
            error.message = error.text();
        }
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }

    trackBranchById(index: number, item: Branch) {
        return item.id;
    }
}

@Component({
    selector: 'jhi-marketplace-popup',
    template: ''
})
export class MarketplacePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor(
        private route: ActivatedRoute,
        private marketplacePopupService: MarketplacePopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe((params) => {
            if ( params['id'] ) {
                this.modalRef = this.marketplacePopupService
                    .open(MarketplaceDialogComponent, params['id']);
            } else {
                this.modalRef = this.marketplacePopupService
                    .open(MarketplaceDialogComponent);
            }
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/marketplace/marketplace-dialog.component.ts